import * as React from 'react';
import { displayNameForIntegrationType, iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { IntegrationType } from '../../types';
import { antGrey, runwayColors } from '../styles/globalStyles';
import { AppComponentProps } from '../../typescriptHelpers';
import {
    getPreferencesForNotifyingOfComingSoonIntegrations,
    setPreferencesForNotifyingOfComingSoonIntegrations,
} from '../../helpers/localStorageHelper';
import TrackedButton from '../../helpers/TrackedButton';
import Typography from 'antd/lib/typography';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import { CheckOutlined } from '@ant-design/icons';
import * as Amplitude from '../../utils/analytics';

interface ComingSoonIntegrationCardProps extends AppComponentProps {
    integrationType: IntegrationType;
}

export const ComingSoonIntegrationCard: React.FC<ComingSoonIntegrationCardProps> = (
    props: ComingSoonIntegrationCardProps,
) => {
    const { integrationType, orgId } = props;

    const initialIntegrationsSavedToGetNotified = getPreferencesForNotifyingOfComingSoonIntegrations(orgId);

    const [integrationsSavedToGetNotified, setIntegrationsSavedToGetNotified] = React.useState(
        initialIntegrationsSavedToGetNotified,
    );

    const saveGetNotifiedClicked = () => {
        const initialIntegrationsSaved = getPreferencesForNotifyingOfComingSoonIntegrations(orgId);
        const updatedIntegrationsSavedToGetNotified = [...initialIntegrationsSaved, integrationType];

        setPreferencesForNotifyingOfComingSoonIntegrations(orgId, updatedIntegrationsSavedToGetNotified);

        setIntegrationsSavedToGetNotified(updatedIntegrationsSavedToGetNotified);
    };

    const displayName = displayNameForIntegrationType(integrationType);
    const [icon, alt] = iconAndAltForIntegrationType(integrationType);

    const alreadySavedToGetNotifiedList = integrationsSavedToGetNotified.includes(integrationType);

    return (
        <div
            style={{
                backgroundColor: antGrey.grey4,
                border: `1px solid ${antGrey.grey8}`,
                borderRadius: 8,
                boxShadow: 'var(--rw-shadow-card)',
                height: 90,
                padding: 25,
                display: 'flex',
                alignItems: 'center',
                gap: 25,
            }}
        >
            {icon && <img key={integrationType} src={icon} alt={alt} width={36} height={36} />}
            <Typography.Text style={{ fontSize: 28, color: antGrey.grey8, flex: 1 }}>{displayName}</Typography.Text>
            {alreadySavedToGetNotifiedList ?
                <Space style={{ marginLeft: 12 }}>
                    <CheckOutlined style={{ color: runwayColors.statusGreen }} />
                    <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            You&apos;ll be notified when this integration is available
                        </Text>
                    </div>
                </Space>
            :   <Space>
                    <Typography.Text style={{ flexGrow: 1, color: runwayColors.primary }}>Coming soon!</Typography.Text>
                    <TrackedButton
                        orgId={orgId}
                        style={{ flexGrow: 1 }}
                        eventName={Amplitude.Event.ClickGetNotified}
                        extraProperties={{
                            integrationType: integrationType,
                        }}
                        onClick={saveGetNotifiedClicked}
                        size="large"
                    >
                        Get notified
                    </TrackedButton>
                </Space>
            }
        </div>
    );
};
